import React, {Component} from "react";
import {
  Panel,
  PanelGroup,
  Button,
  ButtonGroup,
  Modal
}                         from "react-bootstrap";
import moment             from "moment";
import {
  Route,
  Link,
  Switch
}                         from "react-router-dom";

import { REPORTS }        from "actions/const";

import EventNameReport    from "./EventNameReport";
import EventReport        from "./EventReport";

class Report extends Component {
  constructor (props) {
    super(props);

    this.getEventNameReport = this.getEventNameReport.bind(this);
  }

  getEventNameReport () {
    let {
      actions
    } = this.props;

    actions.setValue(
      REPORTS,
      {
        isLoadingEventNameReport: true
      }
    );

    let query = new Parse.Query("CustomEventEventNameReport");

    query.ascending("eventName");

    query.find()
    .then((data) => {

      actions.setValue(
        REPORTS,
        {
          isLoadingEventNameReport: false,
          eventNameReportData: data
        }
      );
    })
    .catch((err) => {
      console.log("error: ", err);

      actions.setValue(
        REPORTS,
        {
          isLoadingEventNameReport: false,
          eventNameReportData: []
        }
      );
    });
  }

  getEventNameReport2 () {
    let {
      reportType
    } = this.state;

    let query = new Parse.Query("CustomEventEventNameReport"),
        renderItem;

    switch (reportType) {
      case 0:
        query = new Parse.Query("CustomEventEventNameReport");

        renderItem = (arrayList, item) => {
          arrayList.push({
            name: item.get("eventName"),
            data: [
              {
                name: "Overall",
                y: item.get("total")
              }
            ]
          });
          return arrayList
        };
        break;
      case 1:
        query = new Parse.Query("CustomEventEventNameDailyReport");
        query.descending("date");
        query.limit(7);

        renderItem = (arrayList, item) => {
          let category = moment(item.get("date")).format("MMM DD");

          let indexOfEvent = arrayList.map((item) => item.name).indexOf(item.get("eventName"));

          if (indexOfEvent === -1) {
            arrayList.push({
              name: item.get("eventName"),
              data: [
                {
                  name: category,
                  y: item.get("total")
                }
              ]
            });
          } else {
            let indexOfCategory = arrayList[indexOfEvent].data.map((item) => item.name).indexOf(category);

            if (indexOfCategory === -1) {
              arrayList[indexOfEvent].data.push({
                name: category,
                y: item.get("total")
              });
            }
          }

          return arrayList.map((item) => ({
            ...item,
            data: [...item.data.map((item) => ({...item}))].sort((a, b) => {
              if (a.name < b.name) {
                return -1;
              } else if (a.name > b.name) {
                return 1;
              };
              return 0
            })
          }));
        };
        break;
      case 2:
        query = new Parse.Query("CustomEventEventNameWeeklyReport");
        query.descending("date");
        query.limit(7);

        renderItem = (arrayList, item) => {
          let category = `Week ${item.get("isoWeekNumber")}`;

          let indexOfEvent = arrayList.map((item) => item.name).indexOf(item.get("eventName"));

          if (indexOfEvent === -1) {
            arrayList.push({
              name: item.get("eventName"),
              data: [
                {
                  name: category,
                  y: item.get("total")
                }
              ]
            });
          } else {
            let indexOfCategory = arrayList[indexOfEvent].data.map((item) => item.name).indexOf(category);

            if (indexOfCategory === -1) {
              arrayList[indexOfEvent].data.push({
                name: category,
                y: item.get("total")
              });
            }
          }

          return arrayList.map((item) => ({
            ...item,
            data: [...item.data.map((item) => ({...item}))].sort((a, b) => {
              if (a.name < b.name) {
                return -1;
              } else if (a.name > b.name) {
                return 1;
              };
              return 0
            })
          }));
        };
        break;
      case 3:
        query = new Parse.Query("CustomEventEventNameMonthlyReport");
        query.descending("date");
        query.limit(7);

        renderItem = (arrayList, item) => {
          let category = `Month ${item.get("monthNumber")}`;

          let indexOfEvent = arrayList.map((item) => item.name).indexOf(item.get("eventName"));

          if (indexOfEvent === -1) {
            arrayList.push({
              name: item.get("eventName"),
              data: [
                {
                  name: category,
                  y: item.get("total")
                }
              ]
            });
          } else {
            let indexOfCategory = arrayList[indexOfEvent].data.map((item) => item.name).indexOf(category);

            if (indexOfCategory === -1) {
              arrayList[indexOfEvent].data.push({
                name: category,
                y: item.get("total")
              });
            }
          }

          return arrayList.map((item) => ({
            ...item,
            data: [...item.data.map((item) => ({...item}))].sort((a, b) => {
              if (a.name < b.name) {
                return -1;
              } else if (a.name > b.name) {
                return 1;
              };
              return 0
            })
          }));
        };
        break;
      case 4:
        query = new Parse.Query("CustomEventEventNameQuarterlyReport");
        query.descending("date");
        query.limit(7);

        renderItem = (arrayList, item) => {
          let category = `Quarter ${item.get("quarterNumber")}`;

          let indexOfEvent = arrayList.map((item) => item.name).indexOf(item.get("eventName"));

          if (indexOfEvent === -1) {
            arrayList.push({
              name: item.get("eventName"),
              data: [
                {
                  name: category,
                  y: item.get("total")
                }
              ]
            });
          } else {
            let indexOfCategory = arrayList[indexOfEvent].data.map((item) => item.name).indexOf(category);

            if (indexOfCategory === -1) {
              arrayList[indexOfEvent].data.push({
                name: category,
                y: item.get("total")
              });
            }
          }

          return arrayList.map((item) => ({
            ...item,
            data: [...item.data.map((item) => ({...item}))].sort((a, b) => {
              if (a.name < b.name) {
                return -1;
              } else if (a.name > b.name) {
                return 1;
              };
              return 0
            })
          }));
        };
        break;
      case 5:
        query = new Parse.Query("CustomEventEventNameYearlyReport");
        query.descending("date");
        query.limit(7);

        renderItem = (arrayList, item) => {
          let category = `Year ${item.get("yearNumber")}`;

          let indexOfEvent = arrayList.map((item) => item.name).indexOf(item.get("eventName"));

          if (indexOfEvent === -1) {
            arrayList.push({
              name: item.get("eventName"),
              data: [
                {
                  name: category,
                  y: item.get("total")
                }
              ]
            });
          } else {
            let indexOfCategory = arrayList[indexOfEvent].data.map((item) => item.name).indexOf(category);

            if (indexOfCategory === -1) {
              arrayList[indexOfEvent].data.push({
                name: category,
                y: item.get("total")
              });
            }
          }

          return arrayList.map((item) => ({
            ...item,
            data: [...item.data.map((item) => ({...item}))].sort((a, b) => {
              if (a.name < b.name) {
                return -1;
              } else if (a.name > b.name) {
                return 1;
              };
              return 0
            })
          }));
        };
        break;
    }

    query.find()
    .then((data) => {
      let eventNameReportData = [];

      for (let item of data) {
        eventNameReportData = renderItem(eventNameReportData, item);
      }

      this.setState({
        eventNameReportData
      });
    })
    .catch((err) => {
      console.log("error: ", err);
    });
  }

  getData () {
    let query = new Parse.Query("CustomEventReport");

    query.find()
    .then((result) => {
      let categories = [],
          data = [];

      for (let item of result) {
        categories.push(item.get('value'));
        data.push(item.get("total"));
      }

      this.setState({
        categories,
        data
      });
    })
    .catch((err) => {
      console.log("error: ", err);
    });
  }

  render () {
    let {
      Reports,
      actions
    } = this.props;

    let {

    } = Reports;

    let eventNameReportProps = {
      ...this.props
    };

    return (
      <div>
        {/*<Panel>
          <Panel.Heading style={{
            backgroundColor: '#D1282F',
            color: 'white'
          }}>
            <h4>Report</h4>
          </Panel.Heading>
          <Panel.Body>*/}
            <Switch>
              <Route
                exact
                path={`${this.props.match.url}/:id`}
                render={(props) => <EventReport {...props}/>}
                />
              <Route
                exact
                path={`${this.props.match.url}`}
                render={(props) => <EventNameReport {...eventNameReportProps} {...props}/>}
                />
            </Switch>
          {/*</Panel.Body>
        </Panel>*/}
      </div>
    );
  }

  componentDidMount () {
    this.getEventNameReport();
  }
}

import {connect}            from 'react-redux';
import {bindActionCreators} from 'redux';
import {generics}           from 'actions';

function mapStateToProps(state) {
	let {
    Reports
	} = state;

	return {
    Reports
  };
}

function mapDispatchToProps(dispatch) {
  const actions = {
    setValue: generics.setValue
  };

  return {
    actions: bindActionCreators(actions, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Report);



// WEBPACK FOOTER //
// ./components/Report/index.js